import { render, staticRenderFns } from "./TenantCurrent.vue?vue&type=template&id=715f93e8&"
import script from "./TenantCurrent.vue?vue&type=script&lang=ts&"
export * from "./TenantCurrent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports